import { Box, Tooltip, Typography } from '@mui/material'
import { Warning, Info, Sync } from '@mui/icons-material'
import { ReactElement } from 'react'
import {
  MigrationStatus,
  getMigrationStatusDisplay,
} from '../utils/migration-status'

type MigrationStatusBadgeProps = {
  status: MigrationStatus
}

export default function MigrationStatusBadge({
  status,
}: MigrationStatusBadgeProps): ReactElement | null {
  if (status.kind === 'none') {
    return null
  }

  let display = getMigrationStatusDisplay(status)

  let IconComponent =
    display.iconType === 'warning'
      ? Warning
      : display.iconType === 'sync'
        ? Sync
        : Info

  return (
    <Tooltip title={display.tooltipText}>
      <Box
        className="flex items-center gap-1"
        data-tour="create-course-migration-badge"
      >
        <IconComponent
          fontSize="small"
          sx={{
            color: display.iconColor,
          }}
        />
        <Typography
          variant="body2"
          sx={{
            color: display.color === 'error' ? 'error.main' : 'warning.main',
          }}
        >
          {display.label}
        </Typography>
      </Box>
    </Tooltip>
  )
}
